import styled, { css } from 'styled-components';
import { space } from 'styled-system';
import ReactSelect from 'react-select';

export const Input = styled.input`
  height: 33px;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  padding: 0.375rem 0.75rem;
    ${(props) => props.type === 'radio' && css`
    height: 20px;
    width: auto;
  `}
  ${(props) => props.disabled && css`
    background-color: #FAFAFA;
    border: 1px solid #DEE1EC;
  `}
  ${(props) => props.hasError && css`
    border: 1px solid red;
  `}
`;

export const Select = styled.select`
  ${space};
  position: relative;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  max-width: 100%;
  overflow: hidden;
  border: 1px solid #D9D9D9;
  background: white;
  padding: 0 10px;
  padding-right: 30px;
  font-size: 12px;
  height: 33px;
  white-space: nowrap;
  ${(props) => props.disabled && css`
    background-color: #FAFAFA;
    border: 1px solid #DEE1EC;
  `}
  &::after {
    content: "";
    position: absolute;
    pointer-events: none;
    width: 20px;
    top: 0;
    bottom: 0;
    right: 0;
    background-image: url('/j/images/select-arrow-down.svg');
    background-repeat: no-repeat;
    background-position-y: center;
  }
`;

export const TextArea = styled.textarea`
  ${(props) => props.disabled && css`
    background-color: #FAFAFA;
    border: 1px solid #DEE1EC;
  `}
`;

export const QuestionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  ${space};
  ${Input} {
    ${(props) => props.hasError && css`
      border: 1px solid red;
    `}
  }
  ${Select} {
    ${(props) => props.hasError && css`
      border: 1px solid red;
    `}
  }
`;

export const QuestionLabel = styled.label`
  line-height: 1.5;
  white-space: pre-line;
  font-size: 13px;
  font-weight: 600;
  ${(props) => props.isRequired && css`
    &:after {
      content: '*';
      color: red;
      margin-left: 4px
    }`}
  ${(props) => props.disabled && css`
    & {
      opacity: 0.5;
    }
  `}
`;

export const RadioLabel = styled.label`
  font-size: 12px;
  color: ${(props) => props.theme.colors.gray90};
  margin-left: 9px;
`;

export const QuestionErrorMessage = styled.div`
  color: red;
`;

export const OptionalQuestionWarningMessage = styled.div`
  color: gray;
  margin-top: -5px;
  font-size: 12px;
`;

export const InputRowWrapper = styled.div`
    &:hover {
    }
`;

export const Button = styled.button`
    cursor: pointer;
    border-radius: 4px;
    background: #0D8CE6;
    height: 33px;
    color: #fff;
    border: 1px solid #108ee9;
    padding: 0 15px;
    font-size: 14px;
    ${(props) => props.loading && css`
      pointer-events: none;
      opacity: 0.8;
      &:after {
        content: '...'
      }
    `}
    ${(props) => props.disabled && css`
      pointer-events: none;
      opacity: 0.5;
    `}

`;

export const SecondaryButton = styled(Button)`                                 
    color: #666666;
    background: white;
    border: 1px solid #d9d9d9;
    ${(props) => props.disabled && css`
      pointer-events: none;
      opacity: 0.5;
    `}

`;

export const ActionWrap = styled.div`
  cursor: pointer;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: ${(props) => (props.selected ? '#EEF6FC' : 'white')};
  border: 1px solid #e3e4e6;
  border-color: ${(props) => (props.selected ? 'transparent' : '#e3e4e6')};
  border-radius: 4px;
  padding: 20px;
  padding-bottom: 10px;
  position: relative;
  &:hover {
    background-color: #EEF6FC;
    border-color: transparent;
  };
  ${(props) => props.selected && css`
    &::after {
      position: absolute;
      left: 4px;
      top: 4px;
      bottom: 4px;
      content: '';
      width: 3px;
      border-radius: 100px;
      background: #0D8CE6;
    }
  `}
`;

export const DeleteButton = styled.button`
    ${space};
    appearance: none;
    cursor: pointer;
    border: none;
    width: 15px;
    height: 18px;
    background: url(/images/employee-onboarding/delete-question.svg);
`;

export const CustomSelect = styled(ReactSelect)`
  & .Select__control {
    border: 1px solid #d9d9d9;
    box-shadow: none;
    border-radius: 2px;
    &:hover {
      border: 1px solid #d9d9d9;
    }

    &.Select__control--is-focused {
      box-shadow: 0 0 0 1px black;
    }
  }

  & .Select__indicator-separator {
    display: none;
  }

  & .Select__input {
    font-family: Arial;
    font-size: 12px;
    padding-top: 0;
    padding-bottom: 0;
  }

  & .Select__single-value {
    font-family: Arial;
    font-size: 12px;
  }
  
  & .Select__option {
    font-family: Arial;
    font-size: 12px;
  }
  
  & .Select__value-container {
    padding-top: 0;
    padding-bottom: 0;
  }

  & .Select__placeholder {
    font-family: Arial;
    font-size: 12px;
    color: black;
  }
`;
